module.exports = __webpack_public_path__ + "img/13_32.c0d8be2a.png";